define('helper-content-getQuizGame',['exports', './content--get-entity.es', './component--get-content.es'], function (exports, _contentGetEntity, _componentGetContent) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _contentGetEntity2 = _interopRequireDefault(_contentGetEntity);

    var _componentGetContent2 = _interopRequireDefault(_componentGetContent);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var f = function f(ID, contentEntities) {
        var entity = (0, _contentGetEntity2.default)(ID, contentEntities),
            res = {
            ID: '',
            isQuizGame: false,
            content: null
        };

        if (!entity) {
            return res;
        }

        var componentsJSON = entity.contentEntity.componentsJson ? JSON.parse(entity.contentEntity.componentsJson) : [],
            content = (0, _componentGetContent2.default)(componentsJSON, 'QuizGame');

        if (Object.keys(content).length) {
            return {
                ID: entity.contentEntityId,
                isQuizGame: true,
                content: content
            };
        } else if (entity.contentEntity.parentId) {
            return f(entity.contentEntity.parentId, contentEntities);
        }

        return res;
    };

    exports.default = function (ID, contentEntities) {
        return f(ID, contentEntities);
    };
});
